import { createTheme } from "@mui/material";

const theme = createTheme({
    palette: {
      secondary: {
        main: '#1c1c24',
        contrastText: '#fff',
      },
      success: {
        main: '#00a67d',
        contrastText: '#fff',
      },
      warning: {
        main: '#f9794d',
        contrastText: '#fff',
      },
    },
    typography: {
      fontFamily: ['Plus Jakarta Sans','arial'].join(','),
      fontSize: 15,
      color: '#1c1c24',
      h1: {fontSize: '2em', fontFamily: ['Permanent Marker', 'arial'].join(',')},
      h2: {fontSize: '1.8em'},
      h3: {fontSize: '1.6em'},
      h4: {fontSize: '1.4em'},
      h5: {fontSize: '1.2em'},
      h6: {fontSize: '1.1em'},
    },
});

export default theme;